export const TRUELAYER_SUCCESS = 'success';
export const TRUELAYER_FAILURE = 'failure';
export const TRUELAYER_CANCEL = 'cancel';
// Backend flags a migrating bank's failed auth with sub_code=ProviderMigrated
// and the successor bank id in error_detail, so we can prompt a reconnect.
export const TRUELAYER_PROVIDER_MIGRATED = 'provider_migrated';
